{
  "version": 1,
  "asset_id": "b10a3565-7d7c-4296-b863-c54cba31ceff",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b10a3565-7d7c-4296-b863-c54cba31ceff/hiatal-normal-es-v3-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b10a3565-7d7c-4296-b863-c54cba31ceff/hiatal-normal-es-v3-1200.webp",
  "original_filename": "hiatal-normal-es-v3-1200.webp",
  "size": 155764,
  "content_type": "image/webp",
  "created_at": "2026-10-28T23:12:09Z"
}
